import Model from './Model';

export default class TrackingLink extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'tracking-links';
  }
}
